import type { TagColor } from './tagging.types'

export const TAG_COLORS: TagColor[] = [
  'gray',
  'green',
  'yellow',
  'orange',
  'pink',
  'blue',
]

export const DEFAULT_TAG_COLOR: TagColor = 'gray'

export const MAX_TAG_NAME_LENGTH = 24
